export default "__VITE_ASSET__C5Zcn7oK__"